import { useEffect, useState } from "react";
import { WifiSlash } from "@phosphor-icons/react";

/** Thin offline banner that appears when the browser loses connectivity. */
export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[2500] bg-[#ef4444] text-white text-[10px] uppercase tracking-[0.25em] font-bold py-1.5 px-4 flex items-center justify-center gap-2" data-testid="offline-banner">
      <WifiSlash size={12} weight="fill" /> Offline — Showing cached fleet snapshot
    </div>
  );
}
